import React from 'react'
import FilterReset from '../Includes/Filter/FilterReset'
import HeuresToolbarContent from './HeuresToolbarContent'
import ButtonFilter from '../Includes/Button/ButtonFilter'
import {
  useSelector
} from 'react-redux'
import {
  isDifferent
} from '../../Functions/Compare'
import {
  filtres
} from '../../Variables/Variables'

const HeuresToolbarMobile = ({
  setPage,
  setFilter
}) => {
  const heures = useSelector(state => state.heures.heures)
  const filters = useSelector(state => state.filters.pages)
  const notification = useSelector(state => state.notifications.notification)
  return (
    <div className="toolbar-actions-mobile">
      <HeuresToolbarContent/>
      {
        (heures.length > 0)
          ? (notification === '')
            ? <ButtonFilter
                onClick={() => setFilter(true)}
              />
            : <FilterReset notification={true}/>
          : null
      }
      {
        (isDifferent([filters.heures], [filtres.heures]))
          ? <FilterReset
              target="heures"
              callback={() => setPage(0)}
            />
          : null
      }
    </div>
  )
}

export default HeuresToolbarMobile
